import React from 'react';
import UserAuthAvatar from '../UserAuthAvatar';

export const Header: React.FC = () => {
  return (
    <header className="h-[64px] bg-card border-b border-border flex items-center justify-end px-6">
      <div className="flex items-center space-x-4">
        <UserAuthAvatar />
      </div>
    </header>
  );
};
